// Browser calls for an A/B Testing campaign's experiment (server: routes/api/worker/ab_routes.js).
// Each call resolves to the server's JSON body, or throws an Error carrying the server's message
// (the api-worker's reason when there is one), ready for a toast.
import axios from 'axios';

const experimentUrl = (appUrl, campaignId) => `${appUrl}/api/cux/ab/${encodeURIComponent(campaignId)}/experiment`;

export async function unwrap(request) {
    try {
        const { data } = await request;
        return data;
    } catch (err) {
        throw new Error(err?.response?.data?.message || err?.message || 'A/B test request failed');
    }
}

export const abApi = {
    create: (appUrl, campaignId) => unwrap(axios.post(experimentUrl(appUrl, campaignId), {}, { withCredentials: true })),
    update: (appUrl, campaignId) => unwrap(axios.put(experimentUrl(appUrl, campaignId), {}, { withCredentials: true })),
    setStatus: (appUrl, campaignId, status) => unwrap(axios.post(`${experimentUrl(appUrl, campaignId)}/status`, { status }, { withCredentials: true })),
    get: (appUrl, campaignId, { from, to } = {}) => unwrap(axios.get(experimentUrl(appUrl, campaignId), { params: { from, to }, withCredentials: true })),
    remove: (appUrl, campaignId) => unwrap(axios.delete(experimentUrl(appUrl, campaignId), { withCredentials: true })),
};
